import React, { ReactNode } from 'react';
import { DocOverview } from '../../types/docs';
import { useSiteMetadataVersions } from '../../queries/useSiteMetadataVersions';
import Navbar from '../navbar/Navbar';
import Banner from '../banner/Banner';
import AnnouncementBanner from '../banner/AnnouncementBanner';
import Footer from '../footer/Footer';
import MainContent from '../mainContent';
import Sidebar from '../sidebar/Sidebar';
import { isSearchScreen } from '../../utils/screenRouteChecks';
import { useLocation } from '../../contexts/useLocation';

const Layout = ({
  children,
  root,
  version,
  categoryVersions,
  title,
  permalink,
  id,
}: {
  children: ReactNode;
  title: string | undefined;
  permalink: string;
  root: DocOverview | undefined;
  version: string;
  categoryVersions: string[];
  id: string | undefined;
}) => {
  const { latestVersion } = useSiteMetadataVersions();
  const docs = root?.children ?? [];
  const location = useLocation();
  const hasRoot = root !== undefined;
  const isSearch = isSearchScreen(location.pathname);

  function isLandingPage(): boolean {
    return location.pathname === '/';
  }

  return (
    <div className={`flex flex-col ${isLandingPage() || isSearch ? 'md:h-screen' : ''}`}>
      <AnnouncementBanner />
      <div className="flex flex-row flex-1 min-h-0">
        <div className="flex flex-col">
          {hasRoot && docs && (
            <Sidebar
              categoryVersions={categoryVersions}
              docs={docs}
              version={version}
              title={title ? title : ''}
              permalink={permalink}
            />
          )}
        </div>
        <div className="flex flex-col min-w-0 w-full min-h-0">
          <Navbar version={version ? version : latestVersion} />
          <div
            className={`flex flex-col w-full ${isLandingPage() || isSearch ? 'pb-0 min-h-0 flex-1 overflow-y-auto' : 'pb-[20vh] xl:pb-[35vh]'}   ${(hasRoot && docs) || isSearch ? 'main-content' : ''}`}
            id={`permalink-${permalink} `}
          >
            {isLandingPage() && <Banner />}
            <MainContent
              permalink={permalink}
              root={root}
              version={version}
              title={title}
              id={id}
              categoryVersions={categoryVersions}
            >
              {children}
            </MainContent>
          </div>
          {isLandingPage() && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default Layout;
